<template>
  <section id="menu">
    <el-menu
      background-color="#fff"
      text-color="#232323"
      active-text-color="#3366E8"
      :default-active="curSecondMenu"
      @select="setCurSecondMenu"
    >
      <el-menu-item v-for="item in secondMenuList" :key="item.id" :index="item.id" @click="clickMenuItem(item)">
        <i v-if="item.menuIcon" class="icon iconfont" :class="item.menuIcon"></i>
        <i v-else class="icon el-icon-menu"></i>
        <span>{{ item.name }}</span>
      </el-menu-item>
    </el-menu>
  </section>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Menu',
  data() {
    return {
      serviceIndex: 0
    }
  },
  computed: {
    ...mapState('menu', ['curSecondMenu']),
    ...mapGetters('menu', ['secondMenuList'])
  },
  methods: {
    ...mapMutations('menu', ['setCurSecondMenu']),
    clickMenuItem(menu) {
      this.$router.push({ path: '/eipManage/' + menu.alias })
    }
  }
}
</script>
<style lang="scss" scoped>
#menu {
  background-color: #fff;
  box-shadow: 0 4px 11px rgba(0, 0, 0, 0.06);
  .el-menu {
    border-right: none;
  }
  .el-menu-item {
    height: 42px;
    line-height: 42px;
    border: 2px solid transparent;
    font-size: 16px;
    .icon {
      margin-right: 15px;
      font-size: 20px;
      vertical-align: middle;
    }
    &.is-active {
      background-color: #ebf0ff !important;
      border-left-color: #3366e8;
    }
    &:hover {
      background-color: #ebf0ff !important;
    }
  }
}
</style>
